export default __webpack_public_path__ + "static/branding-52e518d3768f0523326a05cea4183cfe.webp";